import { takeEvery, call, put, all, fork, select } from 'redux-saga/effects';
import { UPDATE_TASK, TOGGLE_STAR, actionCreators } from './action';
import { actionCreators as actionCreatorsTasksList} from '../TasksList/action';
// import firebase from 'firebase';
// import ReduxSagaFirebase from 'redux-saga-firebase';
// import apiKeys from '../../constants/apiKeys';
// import moment from 'moment';
// import {user} from '../../selectors/user';
import { reduxSagaFirebase } from '../../rootFirebase';
import {user} from '../../selectors/user';
import {tasks} from '../../selectors/tasks';

export function* updateTaskSaga({payload}) {
    const idTask = payload;

    const tasksLocal = yield select(tasks);
    const doneLocal = tasksLocal[idTask].done;
    yield put(actionCreatorsTasksList.patchTask({id: payload, done: !doneLocal}));

    const userId = yield select(user);
    
    const done = yield call(reduxSagaFirebase.database.read, `tasks/${userId}/${idTask}/done`);

	yield call(reduxSagaFirebase.database.patch, `tasks/${userId}/${idTask}`, {
       done: !done
      });

	yield put(actionCreatorsTasksList.fetchTasks());
}

export function* toggleStarTaskSaga({payload}) {
    const idTask = payload;

    const tasksLocal = yield select(tasks);
    const focusLocal = tasksLocal[idTask].focus;

    yield put(actionCreatorsTasksList.patchTask({id: payload, focus: !focusLocal}));
    
    const userId = yield select(user);
    const focus = yield call(reduxSagaFirebase.database.read,  `tasks/${userId}/${idTask}/focus`);

	yield call(reduxSagaFirebase.database.patch, `tasks/${userId}/${idTask}`, {
       focus: !focus
      });

	yield put(actionCreatorsTasksList.fetchTasks());
}


export function* updateTask() {
	yield takeEvery(UPDATE_TASK, updateTaskSaga);
}

export function* toggleStarTask() {
	yield takeEvery(TOGGLE_STAR, toggleStarTaskSaga);
}



export function* tasksSaga() {
	yield all([ fork(updateTask), fork(toggleStarTask) ]);
}
